<template>
  <v-container class="custom-container">
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-0 rounded-0 faq-card" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                <v-card-title>
                  <v-icon class="mr-3" color="greenMain">mdi mdi-file-document-outline</v-icon>
                  Terms And Condition You Agreed
                </v-card-title>
                <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
                  <v-data-table hide-default-footer :headers="headers" :items="notAcceptedAgreements">
                    <template v-slot:item.agreement_file="{ item }">
                      <a class="links text-decoration-none" target="_blank" rel="noopener noreferrer"
                        :href="item.agreement_file">
                        <img class="mt-2" width="30px" alt="pdf" src="@/assets/pdf-sm.png" />
                      </a>
                    </template>
                    <template v-slot:item.DetailsView="{ item }">
                      <a
                        class="links text-decoration-none mx-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="item.agreement_file"
                      >
                        <v-icon small color="#14D7B2">
                        mdi-eye-outline
                        </v-icon>
                      </a>
                      <!-- <a
                        class="links text-decoration-none mx-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="#"
                        @click.prevent="downloadFile(item.agreement_file)"
                      >
                        <v-icon small color="#14D7B2">
                          mdi-download
                        </v-icon>
                        
                      </a> -->
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import { mapState, mapActions } from "vuex";
import { AGREEMENT__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  data() {
    return {
      dialog: {},
      selectedFile: null,
      uploading: false,
      headers: [
        { text: "Agreement For", value: "title", align: "start" },
        { text: "Uploaded Date", value: "created_at" },
        { text: "Broker's File", value: "agreement_file" },
        { text: "Actions", value: "DetailsView" },
      ],
    };
  },
  computed: {
    ...mapState("agreements", ["notAcceptedAgreements"]),
  },
  methods: {
    ...mapActions("agreements", [AGREEMENT__ACTIONS.NOTACCEPTEDAGREEMENTS, AGREEMENT__ACTIONS.UPLOADAGREEMENTFILE]),

    handleClose(item) {
      this.$set(this.dialog, item?.id, false)
    },

    async downloadFile(url) {
      try {
        const response = await fetch(url, { mode: 'cors' });
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', url.split('/').pop());
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        toast.error("Error downloading file:", error);
      }
    },

    handleFileAdded(file) {
      console.log('File added to dropzone:', file);
      this.selectedFile = file;
      
      // Validate file size
      if (file.size > 2 * 1024 * 1024) {
        toast.error("File size should be less than 2MB");
        this.$refs.myVueDropzone.removeFile(file);
        this.selectedFile = null;
      }
    },
    
    async uploadFile(item) {
      if (!this.selectedFile) {
        toast.error("Please select a file to upload!");
        return;
      }
      
      try {
        this.uploading = true;
        const formData = new FormData();
        formData.append("agreement_id", item.id);
        formData.append("agreement_file", this.selectedFile);
        
        const result = await this[AGREEMENT__ACTIONS.UPLOADAGREEMENTFILE](formData);
        
        if (result !== false) {
          this.handleClose(item);
          this.selectedFile = null; // Clear the selected file
          this.$refs.myVueDropzone.removeAllFiles(); // Clear the dropzone
          this.uploading = false;
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
  },
  async created() {
    await this[AGREEMENT__ACTIONS.NOTACCEPTEDAGREEMENTS]();
  },
};
</script>